import { createSlice } from "@reduxjs/toolkit";
import { fetchIndividualAssessments } from "../thunks/fetch-individual-assessments-thunk";
//  fetch IA listings
const initialState = {
    individualAssessments: [],
    empty: true,
    status: "idle",
    error: null
};

export const individualAssessmentsSlice = createSlice({
    name: "individualAssessmentsSlice",
    initialState,
    reducers: {
        resetIndividualAssessments: (state) => {
            state.individualAssessments = []
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchIndividualAssessments.pending, (state) => {
                state.status = "loading"
            })
            .addCase(fetchIndividualAssessments.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.individualAssessments = action.payload;
            })
            .addCase(fetchIndividualAssessments.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
})

export const selectIndividualAssessmentsList = (state) => state.individualAssessmentsSlice.individualAssessments
export const selectIndividualAssessmentsError = (state) => state.individualAssessmentsSlice.error
export const selectIndividualAssessmentsStatus = (state) => state.individualAssessmentsSlice.status